import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum IssueFilter {
    All,
    Outstanding,
    CompletedLastMonth,
    ReportedLastMonth,
    ReportedLastQuarter,
    ReportedLastYear,
    ReportedIssues,

    IssueComments,
    AwaitingReviewSortedBySubmissionDate,
    AwaitingReviewSortedByParish,
    AwaitingReviewPublicSortedByName,
    AwaitingReviewVolunteerSortedByName,
    RejectedInLastMonthSortedByDate,
    AcceptedInLastMonthSortedByDate,
    Unvalidated,
    OutstandingAssignedToCurrentUser
}

export enum IssueOrder {
    Newest,
    Oldest,
    Parish,
    Type,
    Status,
    LogDate,
    TargetDate,
    Priority,
    StatusDescr,
    AdminArea,
    MaintCode,
    LogBy
}

export enum IssueNotificationType {
    Submitted,
    Accepted,
    Updated,
    Rejected,
    Query,
    Completed,
    Deleted,
    Merged
}
